import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function StickyBanner() {
  const {
    formattedTime,
    isExpired
  } = useCountdown();
  const handleCheckoutClick = () => {
    trackInitiateCheckout();
  };
  return <div className="fixed top-0 left-0 w-full z-[9999] banner-gradient animate-banner-pulse px-4 py-2 text-center flex items-center justify-center gap-3 flex-wrap shadow-[0_2px_20px_rgba(230,57,70,0.5)]" data-id="element-296">
      {!isExpired ? <>
          <div className="text-[13px] font-bold text-white sm:text-[11px]" data-id="element-297">
            🔥 <span className="text-brand-yellow" data-id="element-298">OFERTA</span>
          </div>
          <div className="bg-black/10 border border-white/20 rounded-md px-4 py-2 text-[22px] font-black text-brand-yellow tracking-[2px] min-w-[90px] tabular-nums sm:text-lg" data-id="element-299">
            {formattedTime}
          </div>
          <a href="https://www.betterdailyguides.com/cart/51869771923758:1" onClick={handleCheckoutClick} className="bg-brand-yellow text-brand-dark border-none px-4 py-1.5 rounded-full font-black text-xs cursor-pointer no-underline whitespace-nowrap transition-transform duration-200 hover:scale-105" data-id="element-300">
            COMPRAR AHORA
          </a>
        </> : <div className="text-[13px] font-bold text-white" data-id="element-301">
          ✅ Oferta disponible →{' '}
          <a href="https://www.betterdailyguides.com/cart/51869771923758:1" onClick={handleCheckoutClick} className="text-brand-yellow font-black no-underline" data-id="element-302">
            $6.39
          </a>
        </div>}
    </div>;
}